import axios from "axios";
import React, { useState, useEffect } from "react";
import { Config } from "../../../../../Config";
import UploadWidget from "./Components/UploadWidget";

const Employees = (props) => {
  const [UploadCount, setUploadCount] = useState(0);
  const [UploadInProgress, setUploadInProgress] = useState(false);
  const [EmpDataHadErrors, setEmpDataHadErrors] = useState(false);
  const [SalaryHadErrors, setSalaryHadErrors] = useState(false);
  const [WorkIntHadErrors, setWorkIntHadErrors] = useState(false);
  const [WorkExtHadErrors, setWorkExtHadErrors] = useState(false);
  const [HigherEdHadErrors, setHigherEdHadErrors] = useState(false);
  const [LanguageHadErrors, setLanguageHadErrors] = useState(false);
  const [UserDataHadErrors, setUserDataHadErrors] = useState(false);

  var PosFilesCount = 0;
  var CheckFileCountTimer;

  useEffect(() => {
    if (window.localStorage.getItem("TransferInProgress") === "1") {
      document.getElementById("finalStage").click();
    }
    CheckFileCountTimer = setInterval(updatePrevFileCount, 200);
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const validateFileSize = (FileSize, Id) => {
    setTimeout(() => {
      if (FileSize <= 1) {
        document.getElementById(Id).innerHTML = translateText(
          "data_import_widget_error_non_empty"
        );
      }
    }, 100);
  };

  const updatePrevFileCount = () => {
    var Count = 0;
    for (let i = 1; i < 8; i++) {
      if (
        document.getElementById("csv-" + i + "-check") !== null &&
        document
          .getElementById("csv-" + i + "-check")
          .classList.contains("feather-check")
      ) {
        Count++;
      }
    }
    setUploadCount(Count);
  };

  // this function is called after each file is uploaded inside the then promise, to
  // check the uploaded file extension and in case it is wrong (non-csv) it will set an
  // innerHTML for the error <p></p> tag with the relevant Id. FileName and ErrorElementId
  // are passed down as params to the function call and are different for each upload widget and
  // each uploaded file.
  const validateUploadedFileExtension = (FileName, ErrorElementId) => {
    let FileExtention = FileName.slice(FileName.indexOf("."), FileName.length);

    if (document.getElementById(ErrorElementId) !== null) {
      if (FileExtention !== ".csv") {
        document.getElementById(ErrorElementId).innerHTML =
          "Please upload a csv file.";
      }
    }
  };

  // Employee.csv file upload handler
  const uploadEmployeeCSV = () => {
    let EmployeeData = new FormData();
    EmployeeData.append("file", document.getElementById("csv-1-file").files[0]);

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL + Config.DataImportURL + "/api/employee/import",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "multipart/form-data",
      },
      data: EmployeeData,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        validateFileSize(Res.data.fileSize, "csv-1-error");
        updatePrevFileCount();
        if (Res.data.status === "SUCCESS") {
          setEmpDataHadErrors(false);
        } else {
          setEmpDataHadErrors(true);
        }
        validateUploadedFileExtension(Res.data.fileName, "csv-1-error");
        if (Res.data.status === "SUCCESS") {
          updateMandatoriesStatus();
        }
      })
      .catch((Err) => {
        console.log(Err.response);
        setEmpDataHadErrors(true);
        updatePrevFileCount();
      });
  };

  // EmpSalary.csv file upload handler
  const uploadEmployeeSalaryCSV = () => {
    let EmployeeData = new FormData();
    EmployeeData.append("file", document.getElementById("csv-2-file").files[0]);

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.DataImportURL +
        "/api/employee-salary/import",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "multipart/form-data",
      },
      data: EmployeeData,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        validateFileSize(Res.data.fileSize, "csv-2-error");
        updatePrevFileCount();
        if (Res.data.status === "SUCCESS") {
          setSalaryHadErrors(false);
        } else {
          setSalaryHadErrors(true);
        }
        validateUploadedFileExtension(Res.data.fileName, "csv-2-error");
        if (Res.data.status === "SUCCESS") {
          updateMandatoriesStatus();
        }
      })
      .catch((Err) => {
        console.log(Err.response);
        setSalaryHadErrors(true);
        updatePrevFileCount();
      });
  };

  // EmpIntWorkHist.csv file upload handler
  const uploadEmployeeIntWorkHistCSV = () => {
    let EmployeeData = new FormData();
    EmployeeData.append("file", document.getElementById("csv-3-file").files[0]);

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.DataImportURL +
        "/api/employee-int-work-hist/import",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "multipart/form-data",
      },
      data: EmployeeData,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        validateFileSize(Res.data.fileSize, "csv-3-error");
        updatePrevFileCount();
        if (Res.data.status === "SUCCESS") {
          setWorkIntHadErrors(false);
        } else {
          setWorkIntHadErrors(true);
        }
        validateUploadedFileExtension(Res.data.fileName, "csv-3-error");
        if (Res.data.status === "SUCCESS") {
          updateMandatoriesStatus();
        }
      })
      .catch((Err) => {
        console.log(Err.response);
        setWorkIntHadErrors(true);
        updatePrevFileCount();
      });
  };

  // EmpExtWorkHist.csv file upload handler
  const uploadEmployeeExtWorkHistCSV = () => {
    let EmployeeData = new FormData();
    EmployeeData.append("file", document.getElementById("csv-4-file").files[0]);

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.DataImportURL +
        "/api/employee-ext-work-hist/import",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "multipart/form-data",
      },
      data: EmployeeData,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        validateFileSize(Res.data.fileSize, "csv-4-error");
        updatePrevFileCount();
        if (Res.data.status === "SUCCESS") {
          setWorkExtHadErrors(false);
        } else {
          setWorkExtHadErrors(true);
        }
        validateUploadedFileExtension(Res.data.fileName, "csv-4-error");
        if (Res.data.status === "SUCCESS") {
          updateMandatoriesStatus();
        }
      })
      .catch((Err) => {
        console.log(Err.response);
        setWorkExtHadErrors(true);
        updatePrevFileCount();
      });
  };

  // EmpHigherEducation.csv file upload handler
  const uploadEmployeeHigherEducationCSV = () => {
    let EmployeeData = new FormData();
    EmployeeData.append("file", document.getElementById("csv-5-file").files[0]);

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.DataImportURL +
        "/api/employee-higher-education/import",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "multipart/form-data",
      },
      data: EmployeeData,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        validateFileSize(Res.data.fileSize, "csv-5-error");
        updatePrevFileCount();
        if (Res.data.status === "SUCCESS") {
          setHigherEdHadErrors(false);
        } else {
          setHigherEdHadErrors(true);
        }
        validateUploadedFileExtension(Res.data.fileName, "csv-5-error");
        if (Res.data.status === "SUCCESS") {
          updateMandatoriesStatus();
        }
      })
      .catch((Err) => {
        console.log(Err.response);
        setHigherEdHadErrors(true);
        updatePrevFileCount();
      });
  };
  // EmpLanguage.csv file upload handler
  const uploadEmployeeLanguageCSV = () => {
    let EmployeeData = new FormData();
    EmployeeData.append("file", document.getElementById("csv-6-file").files[0]);

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.DataImportURL +
        "/api/employee-language/import",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "multipart/form-data",
      },
      data: EmployeeData,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        validateFileSize(Res.data.fileSize, "csv-6-error");
        updatePrevFileCount();
        if (Res.data.status === "SUCCESS") {
          setLanguageHadErrors(false);
        } else {
          setLanguageHadErrors(true);
        }
        validateUploadedFileExtension(Res.data.fileName, "csv-6-error");
        if (Res.data.status === "SUCCESS") {
          updateMandatoriesStatus();
        }
      })
      .catch((Err) => {
        console.log(Err.response);
        setLanguageHadErrors(true);
        updatePrevFileCount();
      });
  };
  // User.csv file upload handler
  const uploadUserCSV = () => {
    let EmployeeData = new FormData();
    EmployeeData.append("file", document.getElementById("csv-7-file").files[0]);

    let Req = {
      method: "POST",
      baseURL: window._env_.API_URL + Config.DataImportURL + "/api/user/import",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "multipart/form-data",
      },
      data: EmployeeData,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        validateFileSize(Res.data.fileSize, "csv-7-error");
        updatePrevFileCount();
        if (Res.data.status === "SUCCESS") {
          setUserDataHadErrors(false);
        } else {
          setUserDataHadErrors(true);
        }
        validateUploadedFileExtension(Res.data.fileName, "csv-7-error");
        if (Res.data.status === "SUCCESS") {
          updateMandatoriesStatus();
        }
      })
      .catch((Err) => {
        console.log(Err.response);
        setUserDataHadErrors(true);
        updatePrevFileCount();
      });
  };

  const updateMandatoriesStatus = () => {
    props.CheckEmpFilesUpload();
  };

  return (
    <div className="simple-form">
      <section className="form-head">
        <h1>
          {translateText("employee_files")} <p>*</p>
        </h1>
      </section>
      <div className="form-body">
        <p className="info-top">
          {UploadCount +
            " " +
            translateText("of") +
            " " +
            "7 " +
            translateText("files_uploaded_successfully")}
        </p>
        <UploadWidget
          UploadStarted={() => setUploadInProgress(true)}
          UploadEnded={() => setUploadInProgress(false)}
          TrigUpload={() => uploadEmployeeCSV()}
          Enum={"EMPLOYEE"}
          API_Name={"employee"}
          UploadHadErrors={EmpDataHadErrors}
          SwitchErrorState={() => setEmpDataHadErrors(!EmpDataHadErrors)}
          Placeholder="Employee.csv"
          Id="csv-1"
          AnotherUploadInProgress={UploadInProgress}
          FileDeleted={() => updatePrevFileCount()}
          RemoveErrorState={() => setEmpDataHadErrors(undefined)}
          UpdatePrevFileCount={() =>
            (CheckFileCountTimer = setInterval(updatePrevFileCount, 200))
          }
          UpdateMandatoriesStatus={() => updateMandatoriesStatus()}
          LangData={props.LangData}
        />
        <UploadWidget
          UploadStarted={() => setUploadInProgress(true)}
          UploadEnded={() => setUploadInProgress(false)}
          TrigUpload={() => uploadEmployeeSalaryCSV()}
          Enum={"EMPLOYEE_SALARY"}
          API_Name={"employee-salary"}
          UploadHadErrors={SalaryHadErrors}
          SwitchErrorState={() => setSalaryHadErrors(!SalaryHadErrors)}
          Placeholder="EmpSalary.csv"
          Id="csv-2"
          AnotherUploadInProgress={UploadInProgress}
          FileDeleted={() => updatePrevFileCount()}
          RemoveErrorState={() => setSalaryHadErrors(undefined)}
          UpdatePrevFileCount={() =>
            (CheckFileCountTimer = setInterval(updatePrevFileCount, 200))
          }
          UpdateMandatoriesStatus={() => updateMandatoriesStatus()}
          LangData={props.LangData}
        />
        <UploadWidget
          UploadStarted={() => setUploadInProgress(true)}
          UploadEnded={() => setUploadInProgress(false)}
          TrigUpload={() => uploadEmployeeIntWorkHistCSV()}
          Enum={"EMPLOYEE_INT_WORK_HIST"}
          API_Name={"employee-int-work-hist"}
          UploadHadErrors={WorkIntHadErrors}
          SwitchErrorState={() => setWorkIntHadErrors(!WorkIntHadErrors)}
          Placeholder="EmpIntWorkHist.csv"
          Id="csv-3"
          AnotherUploadInProgress={UploadInProgress}
          FileDeleted={() => updatePrevFileCount()}
          RemoveErrorState={() => setWorkIntHadErrors(undefined)}
          UpdatePrevFileCount={() =>
            (CheckFileCountTimer = setInterval(updatePrevFileCount, 200))
          }
          UpdateMandatoriesStatus={() => updateMandatoriesStatus()}
          LangData={props.LangData}
        />
        <UploadWidget
          UploadStarted={() => setUploadInProgress(true)}
          UploadEnded={() => setUploadInProgress(false)}
          TrigUpload={() => uploadEmployeeExtWorkHistCSV()}
          Enum={"EMPLOYEE_EXT_WORK_HIST"}
          API_Name={"employee-ext-work-hist"}
          UploadHadErrors={WorkExtHadErrors}
          SwitchErrorState={() => setWorkExtHadErrors(!WorkExtHadErrors)}
          Placeholder="EmpExtWorkHist.csv"
          Id="csv-4"
          AnotherUploadInProgress={UploadInProgress}
          FileDeleted={() => updatePrevFileCount()}
          RemoveErrorState={() => setWorkExtHadErrors(undefined)}
          UpdatePrevFileCount={() =>
            (CheckFileCountTimer = setInterval(updatePrevFileCount, 200))
          }
          UpdateMandatoriesStatus={() => updateMandatoriesStatus()}
          LangData={props.LangData}
        />
        <UploadWidget
          UploadStarted={() => setUploadInProgress(true)}
          UploadEnded={() => setUploadInProgress(false)}
          TrigUpload={() => uploadEmployeeHigherEducationCSV()}
          Enum={"EMPLOYEE_HIGHER_EDUCATION"}
          API_Name={"employee-higher-education"}
          UploadHadErrors={HigherEdHadErrors}
          SwitchErrorState={() => setHigherEdHadErrors(!HigherEdHadErrors)}
          Placeholder="EmpHigherEducation.csv"
          Id="csv-5"
          AnotherUploadInProgress={UploadInProgress}
          FileDeleted={() => updatePrevFileCount()}
          RemoveErrorState={() => setHigherEdHadErrors(undefined)}
          UpdatePrevFileCount={() =>
            (CheckFileCountTimer = setInterval(updatePrevFileCount, 200))
          }
          UpdateMandatoriesStatus={() => updateMandatoriesStatus()}
          LangData={props.LangData}
        />
        <UploadWidget
          UploadStarted={() => setUploadInProgress(true)}
          UploadEnded={() => setUploadInProgress(false)}
          TrigUpload={() => uploadEmployeeLanguageCSV()}
          Enum={"EMPLOYEE_LANGUAGE"}
          API_Name={"employee-language"}
          UploadHadErrors={LanguageHadErrors}
          SwitchErrorState={() => setLanguageHadErrors(!LanguageHadErrors)}
          Placeholder="EmpLanguage.csv"
          Id="csv-6"
          AnotherUploadInProgress={UploadInProgress}
          FileDeleted={() => updatePrevFileCount()}
          RemoveErrorState={() => setLanguageHadErrors(undefined)}
          UpdatePrevFileCount={() =>
            (CheckFileCountTimer = setInterval(updatePrevFileCount, 200))
          }
          UpdateMandatoriesStatus={() => updateMandatoriesStatus()}
          LangData={props.LangData}
        />
        <UploadWidget
          UploadStarted={() => setUploadInProgress(true)}
          UploadEnded={() => setUploadInProgress(false)}
          TrigUpload={() => uploadUserCSV()}
          Enum={"USER"}
          API_Name={"user"}
          UploadHadErrors={UserDataHadErrors}
          SwitchErrorState={() => setUserDataHadErrors(!UserDataHadErrors)}
          Placeholder="User.csv"
          Id="csv-7"
          AnotherUploadInProgress={UploadInProgress}
          FileDeleted={() => updatePrevFileCount()}
          RemoveErrorState={() => setUserDataHadErrors(undefined)}
          UpdatePrevFileCount={() =>
            (CheckFileCountTimer = setInterval(updatePrevFileCount, 200))
          }
          UpdateMandatoriesStatus={() => updateMandatoriesStatus()}
          LangData={props.LangData}
        />
      </div>
    </div>
  );
};
export default Employees;
